import { createFileRoute, Link } from "@tanstack/react-router"
import { GridList, GridListItem } from "react-aria-components"
import { useTranslation } from "react-i18next"

import Heading from "@/globalComponents/atoms/Heading"
import Icon from "@/globalComponents/atoms/Icon"
import { cn } from "@/utilities/etc"
import { useTheme } from "@/utilities/hooks/useTheme"
import { scopedTo } from "@/utilities/scopedRoutes"

import styles from "./policies.module.css"

export const Route = createFileRoute("/policies")({
  staticData: {
    pageName: "Policies",
  },
  loader: ({ context }) => {
    context.setDocumentThemeMode("root")
  },
  component: PoliciesRouteComponent,
})

export function PoliciesRouteComponent() {
  const { t } = useTranslation()
  const { qrLookupID } = useTheme()

  return (
    <>
      <Heading className="center" level={3} as={1}>
        {t("policies.header")}
      </Heading>

      <GridList
        className={styles.linkList}
        selectionBehavior="replace"
        aria-label={t("policies.header")}
      >
        <GridListItem id="terms-of-use" textValue={t("termsOfUse.header")}>
          <Link
            {...scopedTo("/terms-of-use", qrLookupID)}
            className={cn(styles.links, "bold")}
          >
            <div className={styles.linkIcon}>
              <Icon name="file" />
            </div>
            {t("termsOfUse.header")}
            <Icon name="chevronRight" />
          </Link>
        </GridListItem>

        <GridListItem id="privacy-policy" textValue={t("privacyPolicy.header")}>
          <Link
            {...scopedTo("/privacy-policy", qrLookupID)}
            className={cn(styles.links, "bold")}
          >
            <div className={styles.linkIcon}>
              <Icon name="file" />
            </div>
            {t("privacyPolicy.header")}
            <Icon name="chevronRight" />
          </Link>
        </GridListItem>
      </GridList>
    </>
  )
}
